export default __webpack_public_path__ + "static/media/Drum_img_02.95a1a549.png";